// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3achv","questions":"styles_questions__1Mdmi","footer":"styles_footer__32yKa"};